import svgPanZoom from 'svg-pan-zoom';
import Hammer from 'hammerjs';
import axios from 'axios';

class Stands {
    constructor() {
        this.stands = document.getElementsByName('exhibitorYear[stands][]');
        if (this.stands.length > 0) {
            this.area = null;
            this.bindChangeStand();
            this.getArea();
        }

        this.standsType = document.getElementsByName('exhibitorYear[stand_type_id]');
        if (this.standsType.length > 0) {
            this.bindChangeStandType();
            this.getTotalStandType();
            Stands.setCheckedBox();
        }

        this.planSelector = document.querySelector('.plan-selector-booking-tool');
        if (this.planSelector) {
            this.prefix = this.planSelector.dataset.prefix ? this.planSelector.dataset.prefix : '';
            this.bindPlanSelector(this.planSelector);
        }

        this.listExhibitors = document.querySelector('.control-plan-list');
        if (this.listExhibitors) {
            this.bindPopupListExhibitors(this.listExhibitors);
        }
    }

    bindPopupListExhibitors(item) {
        item.addEventListener('click', () => {
            document.querySelector('.js-lightbox-list').classList.add('visible');
        });
        const boothsExhibitor = document.querySelectorAll('.js-booths-exhibitor');
        if (boothsExhibitor) {
            boothsExhibitor.forEach((item) => {
                item.addEventListener('click', () => {
                    document.querySelector('.js-lightbox-list').classList.remove('visible');
                    this.planSelector.querySelectorAll('path').forEach((e) => {
                        e.classList.remove('showBlinks');
                    });
                    const stands = JSON.parse(item.dataset.stands);
                    stands.forEach((stand) => {
                        const booth = this.planSelector.querySelector(`[data-name="${stand.title}"]`);
                        const boothWithSpace = this.planSelector.querySelector(`[data-name=" ${stand.title}"]`);
                        if (booth) {
                            this.blinksStandsExhibitors(booth, 1);
                        }
                        if (boothWithSpace) {
                            this.blinksStandsExhibitors(boothWithSpace, 1);
                        }
                    });
                });
            });
        }

        const boothsDetails = document.querySelectorAll('.js-details-exhibitor');
        if (boothsDetails) {
            boothsDetails.forEach((item) => {
                item.addEventListener('click', () => {
                    this.getStandExhibitor(item.dataset.exhibitorId);
                });
            });
        }
        Stands.bindClosePopup('.js-close-lightbox-list', '.js-lightbox-list');
    }

    blinksStandsExhibitors(booth, counter) {
        if (counter === 1) {
            booth.classList.toggle('showBlinks');
        }
        if (counter < 7) {
            setTimeout(() => {
                booth.classList.toggle('showBlinks');
                this.blinksStandsExhibitors(booth, counter + 1);
            }, 500);
        }
    }

    bindChangeStand() {
        this.stands.forEach((item) => {
            item.addEventListener('change', () => {
                this.getArea();
                this.updateListStands();
            });
        });
    }

    static isMobile() {
        if (window.screen.width <= 760) {
            return true;
        }

        return false;
    }

    bindPlanSelector(item) {
        this.boothData = JSON.parse(item.dataset.boothData);
        this.panZoom = svgPanZoom(item.querySelector('svg'), {
            zoomEnabled: true,
            // controlIconsEnabled: true,
            dblClickZoomEnabled: false,
            fit: true,
            center: true,
            customEventsHandler: {
                haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
                init(options) {
                    const { instance } = options;
                    let initialScale = 1;
                    let pannedX = 0;
                    let pannedY = 0;

                    // Init Hammer
                    // Listen only for pointer and touch events
                    this.hammer = Hammer(options.svgElement, {
                        inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput,
                    });

                    // Enable pinch
                    this.hammer.get('pinch').set({ enable: true });

                    // Handle double tap
                    this.hammer.on('doubletap', () => {
                        instance.zoomIn();
                    });

                    // Handle pan
                    this.hammer.on('panstart panmove', (ev) => {
                        // On pan start reset panned variables
                        if (ev.type === 'panstart') {
                            pannedX = 0;
                            pannedY = 0;
                        }

                        // Pan only the difference
                        instance.panBy({ x: ev.deltaX - pannedX, y: ev.deltaY - pannedY });
                        pannedX = ev.deltaX;
                        pannedY = ev.deltaY;
                    });

                    // Handle pinch
                    this.hammer.on('pinchstart pinchmove', (ev) => {
                        // On pinch start remember initial zoom
                        if (ev.type === 'pinchstart') {
                            initialScale = instance.getZoom();
                            instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x, y: ev.center.y });
                        }

                        instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x, y: ev.center.y });
                    });

                    // Prevent moving the page on some devices when panning over SVG
                    options.svgElement.addEventListener('touchmove', (e) => { e.preventDefault(); });
                },

                destroy() {
                    this.hammer.destroy();
                },
            },
        });

        const zoomIn = document.getElementById('svg-pan-zoom-zoom-in');
        if (zoomIn) {
            zoomIn.addEventListener('click', () => {
                this.panZoom.zoomIn();
            });
        }

        const zoomOut = document.getElementById('svg-pan-zoom-zoom-out');
        if (zoomOut) {
            zoomOut.addEventListener('click', () => {
                this.panZoom.zoomOut();
            });
        }

        if (document.querySelector('.js-plan-search')) {
            document.querySelector('.js-plan-search').addEventListener('keyup', () => {
                Stands.updateExhibitorList();
            });
        }

        if (Stands.isMobile()) {
            this.panZoom.zoomAtPoint(2, { x: 100, y: 100 });
        } else {
            this.panZoom.zoomAtPoint(item.dataset.zoom ? item.dataset.zoom : 1.3, { x: 700, y: 120 });
        }
        const itemsWithIdWithoutDataname = item.querySelectorAll('[id]:not([data-name]');
        itemsWithIdWithoutDataname.forEach((item) => {
            item.dataset.name = item.id;
        });

        if (document.querySelector('.popup-plan-exhibitors')) {
            document.querySelector('.popup-plan-exhibitor').addEventListener('click', () => {
                document.querySelector('.popup-plan-exhibitor').classList.remove('visible');
            });
            document.querySelector('.popup-plan-exhibitor .lightbox-content').addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }

        if (document.querySelector('.popup-list-exhibitors')) {
            document.querySelector('.popup-list-exhibitors').addEventListener('click', () => {
                document.querySelector('.popup-list-exhibitors').classList.remove('visible');
            });
            document.querySelector('.popup-list-exhibitors .lightbox-content').addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }

        const stands = item.querySelectorAll('[data-name]');
        stands.forEach((stand) => {
            const name = stand.dataset.name.replace(/\s/g, '').replace('_', '');
            if (this.boothData[name]) {
                if (this.boothData[name].exhibitor) {
                    stand.innerHTML = `<title>${this.boothData[name].exhibitor}</title>`;
                }
                stand.classList.add(this.boothData[name].state);
                // Allow click only on non confirmed stands
                if (this.boothData[name].state === 'reserved' || this.boothData[name].state === 'free') {
                    stand.addEventListener('click', () => {
                        const cbox = document.querySelector(`[name="exhibitorYear[stands][]"][value="${this.boothData[name].id}"]`);
                        if (cbox) {
                            cbox.checked = !cbox.checked;
                            stand.classList.toggle('reserved', cbox.checked);
                            stand.classList.toggle('free', !cbox.checked);
                            const event = new Event('change');
                            cbox.dispatchEvent(event);
                        }
                    });
                } else {
                    stand.addEventListener('click', () => {
                        this.getStandExhibitor(this.boothData[name].exhibitorId);
                    });
                }
            }
        });
        this.updateListStands();
    }

    updateListStands() {
        const checkedCbox = document.querySelectorAll('[name="exhibitorYear[stands][]"]:checked');
        const listStands = [];
        checkedCbox.forEach((cbox) => {
            if (cbox.value) {
                const stand = Object.values(this.boothData).find((item) => parseInt(item.id, 10) === parseInt(cbox.value, 10));
                if (stand) {
                    listStands.push(stand.title);
                }
            }
        });
        if (document.querySelector('#js-value-stands')) {
            document.querySelector('#js-value-stands').innerHTML = listStands.join(', ');
        }
    }

    bindChangeStandType() {
        this.standsType.forEach((item) => {
            item.addEventListener('change', () => {
                this.getTotalStandType();
                Stands.setCheckedBox();
            });
        });
    }

    getStandExhibitor(exhibitorId) {
        axios.get(`${this.prefix}/getExhibitor/${exhibitorId}`).then((result) => {
            if (result.data) {
                if (document.querySelector('.popup-plan-exhibitor')) {
                    if (document.querySelector('.popup-plan-exhibitor .name')) {
                        document.querySelector('.popup-plan-exhibitor .name').innerHTML = result.data.title;
                    }
                    if (document.querySelector('.popup-plan-exhibitor .is-member')) {
                        document.querySelector('.popup-plan-exhibitor .is-member').style.display = 'none';
                        if (result.data.is_member) {
                            document.querySelector('.popup-plan-exhibitor .is-member').style.display = 'inline-block';
                        }
                    }
                    if (document.querySelector('.popup-plan-exhibitor .picture')) {
                        if (result.data.picture) {
                            document.querySelector('.popup-plan-exhibitor .picture').innerHTML = `<img class="mr-8" src="${result.data.picture}"/>`;
                        } else {
                            document.querySelector('.popup-plan-exhibitor .picture').innerHTML = '';
                        }
                    }
                    document.querySelector('.js-lightbox').classList.add('visible');
                    if (document.querySelector('.popup-plan-exhibitor .booth-content')) {
                        document.querySelector('.popup-plan-exhibitor .booth-content').innerHTML = result.data.content;
                    }
                }
                Stands.bindClosePopup('.js-close-lightbox', '.js-lightbox');
            }
        });
    }

    static bindClosePopup(closeItem, popupItem) {
        if (document.querySelector(closeItem)) {
            document.querySelector(closeItem).addEventListener('click', () => {
                document.querySelector(popupItem).classList.remove('visible');
                if (document.querySelector('.js-plan-search')) {
                    document.querySelector('.js-plan-search').value = '';
                }
                Stands.updateExhibitorList();
            });
        }
    }

    static updateExhibitorList() {
        const element = document.querySelector('.js-plan-search');
        if (element) {
            document.querySelectorAll('.popup-list-exhibitors .exhibitors').forEach((item) => {
                item.classList.toggle('hidden', element.value && item.dataset.title.toLowerCase().indexOf(element.value.toLowerCase()) === -1);
            });
        }
    }

    getArea() {
        this.area = 0;
        this.stands.forEach((item) => {
            if (item.checked && item.dataset.area) {
                this.area += parseFloat(item.dataset.area);
            }
        });
        if (document.querySelector('#js-value-area')) {
            document.querySelector('#js-value-area').innerHTML = this.area;
        }
    }

    getTotalStandType() {
        this.price = null;
        this.discount = null;
        this.totalAfterDiscount = null;
        document.querySelector('#js-discount').classList.add('hidden');
        this.standsType.forEach((item) => {
            if (item.checked && item.dataset.price) {
                this.price = item.dataset.price;
                if (item.dataset.discount) {
                    this.discount = item.dataset.discount;
                }
                if (item.dataset.discount) {
                    this.totalAfterDiscount = item.dataset.totalDiscount;
                }
            }
        });
        if (document.querySelector('#js-value-price')) {
            document.querySelector('#js-value-price').innerHTML = this.price;
        }
        if (this.discount && this.totalAfterDiscount) {
            document.querySelector('#js-value-discount').innerHTML = this.discount;
            document.querySelector('#js-value-after-discount').innerHTML = this.totalAfterDiscount;
            document.querySelector('#js-discount').classList.remove('hidden');
        }
    }

    static setCheckedBox() {
        const inputs = document.getElementsByTagName('input');
        if (inputs) {
            Array.from(inputs).forEach((item) => {
                const box = item.closest('.box');
                if (box) {
                    if (item.checked) {
                        box.classList.add('checked');
                    } else {
                        box.classList.remove('checked');
                    }
                }
            });
        }
    }
}

export default Stands;
